import * as React from 'react';
import PreviewPicker from 'components/PreviewPicker';
import {useFormikContext, Field, FieldProps} from 'formik';

/**
 * The preview part of header component.
 * @return {React.ReactElement}
 * @constructor
 */
export default function Preview(): React.ReactElement {
  const {setFieldValue} = useFormikContext();

  return (
    <Field name="preview">
      {({field}: FieldProps) => (
        <PreviewPicker
          preview={field.value}
          onChange={(file) => (
            setFieldValue(field.name, {
              id: file.id,
              type: file.type,
              url: file.url,
            })
          )}
        />
      )}
    </Field>
  );
}
